<template>
  <div class="row progress_bar_inner">
    <div class="col-5">
      <div class="score_sec">
        <div class="progress_block">
          <div class="state" :class="statusClass(competencySummary.performance,hideScoreForStudent)" style="height: 35px; width: 70px;">
            <span v-if="isScoreNotAvailable || hideScoreForStudent" class="progress_val ace_sec_txt" style="font-size: 15px;">N/A</span>
            <span v-else class="progress_val ace_sec_txt" style="font-size: 15px;" >{{competencySummary.performance.toFixed(2)}}%</span>
            <template v-if="competencySummary.overriddenTime">
              <span @click="openOverrideDetailModal"
                class="score_modify_indicator">
              </span>
            </template>
          </div>
        </div>
        <div class="label">Score</div>
      </div>
    </div>
    <div class="col-7">
      <div class="progress-row">
        <div class="progress-bar-label">{{mcSummary.childrenCompleteCount}} of {{mcSummary.childrenCount}}</div>
        <b-progress :max="mcSummary.childrenCount" height="35px" style="background: rgb(200, 200, 200);">
          <b-progress-bar :value="mcSummary.childrenCompleteCount"  style="background: rgb(142, 178, 86);"></b-progress-bar>
        </b-progress>
      </div>
      <div class="lnk_container" style="margin: 8px 5px 8px 0px; text-align: right;" v-if="!waiveStatus">
        <a href="javascript://" @click="launchCourse">{{launchCourseLabel()}}</a>
      </div>
    </div>
<!-- Override Modal -->
        <div class="modal_popup_container course_unlock_modal edited_score_modal">
          <b-modal ref="learnerCourseOverrideModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
            <div slot="modal-header" class="header-section">
              <div class="head_txt" style="margin-top: 1px;">Edited Overall Score and Progress</div>
              <div class="btn_container">
                <button type="button" class="btn_close" @click="closeLearnerCourseOverrideModal" data-dismiss="modal" aria-label="Close">
                  <span class="ic-close"></span>
                </button>
              </div>
            </div>

            <div class="row txt_row">
              <div class="col-6">
                Course:
              </div>
              <div class="col-6 fld_val">
                <div v-html="competencySummary.titleForStudent"></div>
              </div>
            </div>

              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Actual Overall Score:
                </div>
                <div class="col-6 fld_input" v-if="competencySummary">
                  <span v-if="competencySummary.overriddenTime" class="exp_info">{{competencySummary.prePerformance?competencySummary.prePerformance:0}}%</span>
                  <span v-else class="exp_info">{{competencySummary.performance}}%</span>
                </div>
              </div>
              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Edited Overall Score:
                </div>
                <div class="col-6 fld_input">
                  <span class="exp_info">{{competencySummary.performance}}%</span>
                </div>
              </div>

              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Actual Overall Progress:
                </div>
                <div class="col-6 fld_input progress-row" v-if="competencySummary">
                  <div class="progress-bar-label">
                    {{competencySummary.preChildrenCompleteCount}} of {{competencySummary.childrenCount}}
                  </div>
                  <b-progress :max="competencySummary.childrenCount">
                    <b-progress-bar :value="competencySummary.preChildrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                  </b-progress>
                </div>
              </div>
              <div class="row txt_row mt-3" v-if="competencySummary && competencySummary.overriddenTime>0">
                <div class="col-6 ">
                  Edited Overall Progress:
                </div>
                <div class="col-6 fld_input progress-row">
                  <div class="progress-bar-label">
                    {{competencySummary.childrenCompleteCount}} of {{competencySummary.childrenCount}}
                  </div>
                  <b-progress :max="competencySummary.childrenCount">
                    <b-progress-bar :value="competencySummary.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                  </b-progress>
                </div>
              </div>
              <div class="row txt_row mt-3">
                <div class="col-12 ">
                  Edited By {{competencySummary.overriddenBy}} at  {{millisToDate(competencySummary.overriddenTime)}}
                </div>
              </div>

            <div class="row mt-4">
              <div class="col-12 btn_container" style="text-align: right;">
                <b-button @click="closeLearnerCourseOverrideModal">
                  {{ $tf('ok') }}
                </b-button>
              </div>
            </div>
          </b-modal>
        </div>
<!-- Override Modal -->

  </div>
</template>

<script>
  import { DateTime } from 'luxon'
  import { mapActions } from 'vuex'

  export default {
    name: 'program-course-score-and-progress-bar',
    props: ['courseId','hideScoreForStudent', 'waiveStatus'],
    data: () => {
      return {
        mcSummary: {},
        competencySummary: {},
        isScoreNotAvailable: true,
        index:0
      }
    },
    mounted () {
      this.loadCourseProgress()
    },
    methods: {
      ...mapActions([
        'loadCompetencyProgress',
        'loadMicroCompetencyProgress',
        'loadContinueLearningLast'
      ]),
      async loadCourseProgress () {
        this.mcSummary = await this.loadMicroCompetencyProgress(this.courseId)
        this.competencySummary = await this.loadCompetencyProgress(this.courseId)
        if (!this.competencySummary.performance) {
          this.competencySummary.performance = 0
        }
        let status = this.competencySummary.status
        if ((status === 1) || (status === 2)) {
          this.isScoreNotAvailable = false
        }
        let data = {
          status: status,
          performance: this.competencySummary.performance,
          childrenCount: this.mcSummary.childrenCount,
          childrenCompleteCount: this.mcSummary.childrenCompleteCount
        }
        this.$emit('progressSummary', data)
      },
      statusClass (performance, hideScoreForStudent) {
        if (performance && !this.isScoreNotAvailable, !hideScoreForStudent) {
          if (performance >= 90) {
            return 'gradeA'
          } else if (performance >= 80 && performance < 90) {
            return 'gradeB'
          } else if (performance >= 65 && performance < 80) {
            return 'gradeC'
          } else if (performance >= 40 && performance < 65) {
            return 'gradeD'
          } else if (performance < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      },
      millisToDate (millis) {
        return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
      },
      openOverrideDetailModal () {
        this.$refs.learnerCourseOverrideModal.show()
      },
      closeLearnerCourseOverrideModal () {
        this.$refs.learnerCourseOverrideModal.hide()
      },
      launchCourseLabel () {
        if (this.competencySummary.status < 2) {
          return (this.competencySummary.status === 0) ? 'Start Learning' : 'Continue Learning'
        }else{
          return 'View Course'
        }
      },
      launchCourse () {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
        this.loadContinueLearningLast(this.courseId).then(options => {
          if (options && options.length > 0) {

            if (options[0].title === 'EXTRENAL_COURSE_LAUNCH') {
              let _window = window.open(options[0].uri, '_blank')
               setTimeout(() => {
                  _window.location = options[1].uri
                }, 5000)
              return
            }
            if (options[0].title === 'PARTNER_COURSE_LAUNCH') {
                window.location = options[0].uri
              return
            }

            if (options[0].title !== 'COURSE_FINISHED') {
              return this.$router.push({name: 'courseDashboard', params: {uuid: this.courseId, showLastActivity: true}})
            }
          }
          return this.$router.push({name: 'courseDashboard', params: {uuid: this.courseId}})
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramCourseScoreAndProgressBar.vue